//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import zdialog from "@/components/toast/Zdialog.vue";
import TableGrid from "@/components/tableGrid.vue";
import { config } from "./config"    
import  List  from "./list.vue";
import { InsurStore } from '../../store'
export default {
    data(){
        return {
            title:'月缴',
            message:'',
            
            list:{
                title:['月缴','首月','第2月','第3月','第4月','第5月','第6月'],
                cont:[['金额','6999','6999','6999','6999','6999','6999']]
            }
    
          }
    },
    props: {
        type: {
            type: String,
            default: 'monthly'
        },
    },
    computed: {
        stage_info() {
            return InsurStore.insurance.stage_info
        },
        configItem(){
            return config[this.type]
        }
    },
    components:{
        zdialog,
        TableGrid,
        List
    },
    created(){
        this.title = this.configItem.toastTitle;
        this.configItem.toastInfo().then(res =>{
            this.message = res
        // console.log(this.message)

        })
        if(this.type == 'monthly'){
            const monthAmounts = ['金额(元)'].concat(this.stage_info.month_amounts.map(item => item/100))
            this.$set(this.list,'cont', [monthAmounts])
        }
    },
    mounted () {
        this.$refs.zdialog.showoast();
        this.configItem.toastStatic()
    },
}
